import useInfiniteScroll from '../../hooks/pagination/useInfiniteScroll'

// Results list for the palette: keyboard-highlightable rows + infinite scroll.
// Rendering of each row is delegated to `renderItem(item, { query })` so the
// palette stays generic across features.
function PaletteResults({
  items,
  loading,
  loadingMore,
  hasMore,
  error,
  query,
  activeIndex,
  setActiveIndex,
  onSelect,
  renderItem,
  loadMore,
  listRef,
  emptyLabel = 'No matches.',
}) {
  const sentinelRef = useInfiniteScroll(loadMore, {
    enabled: hasMore && !loading && !loadingMore,
  })

  if (loading) return <div className="palette-status">Searching…</div>
  if (error) return <div className="palette-status">{error}</div>
  if (!items.length) return <div className="palette-status">{emptyLabel}</div>

  return (
    <div className="palette-results" ref={listRef}>
      {items.map((item, index) => (
        <button
          key={item._id || index}
          type="button"
          className={'palette-result' + (index === activeIndex ? ' is-active' : '')}
          onMouseEnter={() => setActiveIndex(index)}
          onClick={() => onSelect(item)}
        >
          {renderItem(item, { query })}
        </button>
      ))}
      {hasMore && (
        <div ref={sentinelRef} className="palette-sentinel">
          {loadingMore ? 'Loading…' : ''}
        </div>
      )}
    </div>
  )
}

export default PaletteResults
